
















































































import { Component, Vue } from 'vue-property-decorator'
import BaseModal from '@/components/ui/BaseModal.vue'
import Glass from '@/data/glass'
import GlassTile from './ui/GlassTile.vue'
import DefaultButton from './ui/DefaultButton.vue'
import NavigationButtons from './ui/NavigationButtons.vue'
import InformationPopup from '@/components/InformationPopup.vue'
import { InformationCodes } from '@/data/enums'
import '@/icons/check'
import '@/icons/swap'
import '@/icons/present'
@Component({
  components: {
    BaseModal,
    GlassTile,
    InformationPopup,
    DefaultButton,
    NavigationButtons
  }
})
export default class GlassSelection extends Vue {
  private currentInformationWebsite: InformationCodes | string = ''
  private glasses: Glass[] = []
  private otherGlasses: Glass[] = []
  private isMulti: boolean = false
  private showInfo: boolean = false

  private get discountTitle (): string {
    return this.$store.state.data.optician.discountTitle
  }

  private showInformationModal (item: Glass) {
    if (item.informationCode) {
      this.currentInformationWebsite = item.informationCode
      this.showInfo = true
    }
  }

  private switchSelection () {
    this.isMulti = !this.isMulti
    for (let i = 0; i < this.glasses.length; i++) {
      if (this.isMulti) {
        this.glasses[i].selected = i % 2 === 0
      } else {
        this.glasses[i].selected = i % 2 !== 0
      }
    }
  }

  private enableOtherGlassType (item: Glass): boolean {
    if (item.informationCode === InformationCodes.GlassTypeScreen) {
      return true
    }
    return false
  }

  private mounted () {
    this.isMulti = this.$store.getters['matrix/adviceMultifocal']
    const singleGlasses = this.$store.state.data.glasses.find((item: Glass) => item.isSingle && !item.sunglasses)
    const singleSunglasses = this.$store.state.data.glasses.find((item: Glass) => item.isSingle && item.sunglasses)
    const multifocalGlasses = this.$store.state.data.glasses.find((item: Glass) => item.isMulti && !item.sunglasses)
    const multifocalSunglasses = this.$store.state.data.glasses.find((item: Glass) => item.isMulti && item.sunglasses)
    this.otherGlasses = this.$store.state.data.glasses.filter((item: Glass) => !item.isMulti && !item.isSingle)

    if (this.isMulti) {
      multifocalGlasses.selected = true
      multifocalSunglasses.selected = true
      singleGlasses.selected = false
      singleSunglasses.selected = false
    } else {
      singleGlasses.selected = true
      singleSunglasses.selected = true
      multifocalGlasses.selected = false
      multifocalSunglasses.selected = false
    }

    this.glasses = [
      multifocalGlasses,
      singleGlasses,
      multifocalSunglasses,
      singleSunglasses
    ]

    this.otherGlasses.forEach((glasses: Glass) => {
      if (glasses.screenGlasses) {
        glasses.selected = this.$store.getters['matrix/adviceScreenGlasses']
      }
    })

    const reading = new Glass({
      id: '4',
      name: 'Reading',
      icon: 'glasstype-reading',
      informationCode: InformationCodes.GlassTypeReading,
      selected: this.$store.getters['matrix/adviceReadingGlasses']
    })
    const sport = new Glass({
      id: '6',
      name: 'Sport',
      icon: 'glasstype-sport',
      informationCode: InformationCodes.GlassTypeSport,
      selected: this.$store.getters['matrix/adviceSportGlasses']
    })
    const lenses = new Glass({
      id: '7',
      name: 'Lenses',
      icon: 'glasstype-lenses',
      informationCode: InformationCodes.GlassTypeLenses,
      selected: this.$store.getters['matrix/adviceLenses']
    })
    this.otherGlasses.push(sport)
    this.otherGlasses.push(reading)
    this.otherGlasses.push(lenses)
  }
}
